import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	csmCustomerContextContactAdmin: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-customer-context-contact-admin',
		defaultMessage: 'Contact your Jira admin to enable or disable this feature.',
		description: 'Prompt in customer service management to contact Jira admin to enable',
	},
	successEnableDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.success-enable-description',
		defaultMessage:
			'Start using customer support features on the customers and organizations pages.',
		description: 'Body text of success flag when feature is enabled',
	},
	successDisableDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.success-disable-description',
		defaultMessage: 'Enable this feature again at any time from the features menu.',
		description: 'Body text of success flag when feature is disabled',
	},
	successEnableAction: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.success-enable-action',
		defaultMessage: 'Go to customers page',
		description: 'Label used in action button in success flag when feature is enabled',
	},
	successEnableDismiss: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.success-enable-dismiss',
		defaultMessage: 'No thanks',
		description: 'Label used in dismiss button in success flag when feature is enabled',
	},
	successDisableDismiss: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.success-disable-dismiss',
		defaultMessage: 'Ok',
		description: 'Label used in dismiss button in success flag when feature is disabled',
	},
	csmDeveloperEscalationsTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-title',
		defaultMessage: 'Developer escalations',
		description: 'Title text of the developer escalations feature panel',
	},
	csmDeveloperEscalationsBadge: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-badge',
		defaultMessage: 'Early Access',
		description: 'Badge text of the developer escalations feature panel',
	},
	csmDeveloperEscalationsDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-description',
		defaultMessage:
			'Streamline developer escalations for your team with a dedicated work category and view. Developers can view, comment, and collaborate with customer service agents on escalated issues that require input from subject matter experts. {learnMoreLink}',
		description:
			'Description that explains the affects of developer escalations. {learnMoreLink} will be replace by a button, it does not need translation',
	},
	csmDeveloperEscalationsLearnMore: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-learn-more',
		defaultMessage: 'Learn more about developer escalations.',
		description: 'Text used in developer escalations learn more link',
	},
	csmDeveloperEscalationsContactSuccessTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-contact-success-title',
		defaultMessage: `Developer escalations {value, select,
            false {disabled}
            true {enabled}
            other {}
        }`,
		description: 'Title text of success flag',
	},
	csmDeveloperEscalationsSuccessEnableDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-success-enable-description',
		defaultMessage:
			'You will now see <strong>Developer escalations</strong> in your project. Add a request type to start using this category.',
		description: 'Body text of success flag when develeper escalations feature is enabled',
	},
	csmDeveloperEscalationSuccessDisableDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalation-success-disable-description',
		defaultMessage: 'You can enable this feature again at any time.',
		description: 'Body text of success flag when develeper escalations feature is disabled',
	},
	csmDeveloperEscalationsSuccessEnableAction: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-success-enable-action',
		defaultMessage: 'Add request type',
		description:
			'Label used in action button in success flag when develeper escalations feature is enabled',
	},
	csmDeveloperEscalationsSuccessEnableDismiss: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-success-enable-dismiss',
		defaultMessage: 'Maybe later',
		description:
			'Label used in dismiss button in success flag when develeper escalations feature is enabled',
	},
	csmDeveloperEscalationsSuccessDisableDismiss: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.csm-developer-escalations-success-disable-dismiss',
		defaultMessage: 'Ok',
		description:
			'Label used in dismiss button in success flag when develeper escalations feature is disabled',
	},
});
